import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ArchitectsService {

  architects: Observable<any[]>;
  page: number = 1;

  constructor(firestore: AngularFirestore) {
    this.architects = firestore.collection('architects').valueChanges({ idField: 'ID' });
  }
}
